// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Dot16Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Dot16: FC<Dot16Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="9"
            height="9"
        >
            <circle cx="4.5" cy="4.5" r="4.5" />
        </svg>
    );
};

export default Dot16;
